import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { useNetworkStatus, useGlobalErrorHandler } from '@/hooks';
import { NetworkStatusBanner } from '@/components/common';
import { cn } from '@/lib/utils';

export function AppShell() {
  const { isOnline, wasOffline, clearWasOffline } = useNetworkStatus();
  useGlobalErrorHandler();

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <NetworkStatusBanner
        isOnline={isOnline}
        wasOffline={wasOffline}
        onDismissRecovery={clearWasOffline}
      />
      <main className={cn('container max-w-full py-6', (!isOnline || wasOffline) && 'pt-16')}>
        <Outlet />
      </main>
    </div>
  );
}
